const COLORS = {
  dark: "dark",
  white: "white"
};
export {
  COLORS
};
//# sourceMappingURL=WsCarySpinner.es.js.map
